module.exports = __webpack_public_path__ + "img/staehr.ecfb97ab.png";